<template>
  <div>
    <v-btn
      absolute
      fab
      flat
      right
      @click="dialog = true"
      style="top: 10px; background-color: #fddf00; width: 40px; height: 40px"
    >
      <v-icon color="black" style="font-size: 35px">add</v-icon>
    </v-btn>
    <newUserDialog
      :newUserDialog="dialog"
      @setDialog="dialog = $event"
      @onSaved="addUser($event)"
    ></newUserDialog>
    <editUserDialog
      :selectedItem="selectedItem"
      :originalUser="originalUser"
      :editDialog="editDialog"
      @setDialog="editDialog = $event"
      @setOriginal="originalUser = $event"
      @onSaved="editUser($event)"
    ></editUserDialog>
    <UserCreditDialog
      :AddCreditDialog="AddCreditDialog"
      @setDialog="AddCreditDialog = $event"
      @onSaved="addCreditUser($event)"
    >
    </UserCreditDialog>
    <v-toolbar dense flat>
      <v-layout row>
        <!-- <v-flex xs8>
        <v-spacer></v-spacer>
      </v-flex>-->
        <v-flex xs12 sm5>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search name / tel / province / district"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-btn @click="AddCredit()" dark round> add credit </v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="loadingMessage"
      :items="filteredUserList"
      :pagination.sync="pagination"
    >
      <template
        slot="items"
        slot-scope="props"
        v-if="props.item.user_role != 6"
      >
        <td class="text-xs-left">
          <v-img :src="props.item.user_partner_image" />
        </td>
        <td class="text-xs-left">
          {{ props.item.user_partner_country_tel
          }}{{ props.item.user_partner_tel }}
        </td>
        <td class="text-xs-left">{{ props.item.user_partner_first_name }}</td>
        <td class="text-xs-left">{{ props.item.user_partner_last_name }}</td>
        <td class="text-xs-left">
          {{ props.item.user_partner_province.province_name_th }}
        </td>
        <td class="text-xs-left body__district">
          <ul>
            <li
              v-for="(info, index) in props.item.user_partner_district"
              :key="index"
            >
              {{ info.district_name_th }}
              <img
                v-if="info.default_payment"
                src="@/assets/back-office/icons/default_manager_icon.svg"
                alt=""
              />
            </li>
          </ul>
        </td>
        <td class="text-xs-center">
          {{ props.item.user_partner_we_credit }}
        </td>
        <td>
          <v-btn
            :to="`/weserve_admin_login/-/manager-manage/transaction/${props.item.user_partner_id}/${props.item.user_partner_first_name}/${props.item.user_partner_last_name}`"
            icon
          >
            <img
              src="@/assets/back-office/icons/transaction.svg"
              alt=""
              width="12px"
            />
          </v-btn>
          <v-btn
            :to="`/weserve_admin_login/-/manager-manage/${props.item.user_partner_id}/${props.item.user_partner_first_name} ${props.item.user_partner_last_name}/${props.item.user_partner_province.province_id}/invoice`"
            icon
          >
            <img
              src="@/assets/back-office/icons/invoice_icon.svg"
              alt=""
              width="12px"
            />
          </v-btn>

          <v-btn @click="toSetDefaultPayment(props.item)" icon>
            <img src="@/assets/back-office/icons/฿.svg" alt="" width="12px" />
          </v-btn>
          <v-btn @click="toChangePassword(props.item)" icon>
            <img
              src="@/assets/back-office/icons/reset_password_manager_icon.svg"
              alt=""
              width="12px"
            />
          </v-btn>
          <v-btn icon @click="editItem(props.item)"
            ><v-icon small>edit</v-icon>
          </v-btn>
          <v-btn icon @click="toDeleteItem(props.item)" :loading="isDeleting">
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="loadingMessage == true">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ "Loading data ..." }}
        </div>
        <div v-else>
          No data available
          <br />
          <v-btn @click="getData()">Reset</v-btn>
        </div>
      </template>
    </v-data-table>
    <v-dialog persistent v-model="dialogPassword" max-width="500">
      <v-card style="border-radius: 10px">
        <v-card-title style="background-color: #fddf00" class="px-4"
          ><h2>Change password</h2>
          <v-spacer></v-spacer
          ><v-icon @click="dialogPassword = false" size="30" color="black"
            >close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4 px-5">
          <v-form v-model="valid" ref="formPassword">
            <v-text-field
              v-model="formPassword.user_partner_password"
              label="New password"
              :append-icon="!show1 ? 'visibility_off' : 'visibility'"
              :type="show1 ? 'text' : 'password'"
              class="input-group--focused"
              @click:append="show1 = !show1"
              :rules="[
                passwordValid.min,
                passwordValid.max,
                (v) => this.isPasswordMatch || 'Password not match',
              ]"
            ></v-text-field>
            <v-text-field
              v-model="formPassword.user_partner_confirm_password"
              label="Confirm password"
              :append-icon="!show2 ? 'visibility_off' : 'visibility'"
              :type="show2 ? 'text' : 'password'"
              class="input-group--focused"
              @click:append="show2 = !show2"
              :rules="[
                passwordValid.min,
                passwordValid.max,
                (v) => this.isPasswordMatch || 'Password not match',
              ]"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="pr-5 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            dark
            color="black"
            style="
              width: 120px;
              background: #000000 0% 0% no-repeat padding-box;
              box-shadow: 0px 3px 6px #00000029;
              border-radius: 7px;
              font-weight: bold;
              letter-spacing: 0.1rem;
            "
            @click="changePassword()"
            :loading="changingPassword"
            >submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="deleteDialog" max-width="500">
      <v-card style="border-radius: 10px">
        <v-card-title class="px-4"
          ><h2>Are you sure you want to delete this user?</h2>
        </v-card-title>
        <v-divider class="mx-4"></v-divider>
        <v-card-actions class="pr-5 py-4">
          <v-spacer></v-spacer>
          <v-btn
            flat
            dark
            color="red"
            style="
              width: 120px;
              border-radius: 7px;
              font-weight: bold;
              font-size: 16px;
            "
            @click="deleteDialog = false"
            :loading="changingPassword"
            >cancel</v-btn
          >
          <v-btn
            flat
            dark
            color="black"
            style="
              width: 120px;
              background-color: #fddf00;
              border-radius: 7px;
              font-weight: bold;
              font-size: 16px;
            "
            @click="deleteItem()"
            :loading="changingPassword"
            >confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="setDefaultPaymentDialog" max-width="500">
      <v-card style="border-radius: 10px">
        <v-card-title style="background-color: #fddf00" class="px-4"
          ><h2>Set Default Payment</h2>
          <v-spacer></v-spacer
          ><v-icon
            @click="setDefaultPaymentDialog = false"
            size="30"
            color="black"
            >close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4 px-5">
          <v-form v-model="valid" ref="formPassword">
            <v-autocomplete
              :items="managerDistrictList"
              item-text="district_name_th"
              item-value="district_id"
              v-model="defaultPaymentForm.user_partner_district_id"
              chips
              clearable
              deletable-chips
              label="Select District"
              multiple
            ></v-autocomplete>
          </v-form>
        </v-card-text>
        <v-card-actions class="pr-5 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            dark
            color="black"
            style="
              width: 120px;
              background: #000000 0% 0% no-repeat padding-box;
              box-shadow: 0px 3px 6px #00000029;
              border-radius: 7px;
              font-weight: bold;
              letter-spacing: 0.1rem;
            "
            @click="submitDefaultPayment()"
            :loading="settingDefault"
            >CONFIRM</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
      <v-icon color="red">close</v-icon>
      {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
      <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
    </v-snackbar>
    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import newUserDialog from "./NewUser";
import editUserDialog from "./EditUser.vue";
import UserCreditDialog from "./AddCredit.vue";
export default {
  data: () => ({
    valid: false,
    show1: false,
    show2: false,
    dialogPassword: false,
    changingPassword: false,
    deleteDialog: false,
    passwordValid: {
      min: (v) => v.length >= 6 || "At least 6 characters",
      max: (v) => v.length <= 24 || "No more than 24 characters",
    },
    search: "",
    loadingMessage: "black",
    pagination: {
      rowsPerPage: 10,
    },
    formPassword: {
      user_partner_id: null,
      user_partner_password: "",
      user_partner_confirm_password: "",
    },
    selectedItem: {
      user_partner_id: null,
      user_partner_first_name: "",
      user_partner_last_name: "",
      user_partner_country_tel: "+66",
      user_partner_tel: "",
      user_partner_image: null,
      user_partner_province_id: null,
      user_partner_district_id: [],
    },
    dialog: false,
    editDialog: false,
    selectedCustomer: null,
    originalUser: null,
    isDeleting: false,
    AddCreditDialog: false,
    headers: [
      {
        text: "Image",
        value: "user_partner_image",
        sortable: false,
      },
      {
        text: "Tel.",
        value: "user_partner_tel",
        sortable: false,
      },
      {
        text: "First name",
        sortable: false,
        value: "user_partner_first_name",
      },
      {
        text: "Last name",
        sortable: false,
        value: "user_partner_last_name",
      },
      {
        text: "Province",
        value: "user_role_name_temp",
        sortable: false,
      },
      {
        text: "District",
        value: "user_type_name_temp",
        sortable: false,
      },
      {
        text: "Balance",
        value: "user_partner_we_credit",
        sortable: false,
        align: "center",
      },
      {
        text: "Actions",
        value: "",
        align: "center",
        sortable: false,
      },
    ],
    editedIndex: null,
    alreadyCheckOTP: false,
    errSnackbar: false,
    snackBarMsg: null,
    userList: [],
    setDefaultPaymentDialog: false,
    defaultPaymentForm: {
      user_partner_id: -1,
      user_partner_district_id: [],
      user_partner_province_id: -1,
    },
    managerDistrictList: [],
    settingDefault: false,
  }),
  components: {
    newUserDialog,
    editUserDialog,
    UserCreditDialog,
  },
  computed: {
    ...mapState({
      indexEditLoading: (state) => state.fetchUserBack.indexEditLoading,
      userData: (state) => state.fetchUserBack.userData,
    }),
    ...mapGetters(["isEditStaff"]),
    pages() {
      this.pagination.totalItems = this.userList.length;
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    filteredUserList() {
      return this.userList.filter(
        (val) =>
          (val.user_partner_first_name + " " + val.user_partner_last_name)
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          (val.user_partner_country_tel + val.user_partner_tel)
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          val.user_partner_province.province_name_en
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          val.user_partner_province.province_name_th
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          val.user_partner_district.some((district) =>
            district.district_name_en
              .toLowerCase()
              .includes(this.search.toLowerCase())
          ) ||
          val.user_partner_district.some((district) =>
            district.district_name_th
              .toLowerCase()
              .includes(this.search.toLowerCase())
          )
      );
    },
    isPasswordMatch() {
      if (
        this.formPassword.user_partner_confirm_password ==
        this.formPassword.user_partner_password
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions({
      setUserToVIP: "fetchUserBack/setUserToVIP",
      changePasswordManager: "fetchUserBack/changePasswordManager",
      setDefaultPaymentManager: "fetchUserBack/setDefaultPaymentManager",
      addCreditManager: "fetchAddcredit/addCreditManager",
    }),
    async addCreditUser(item) {
      let credit = {
        user_partner_id: item.form.managername,
        amount: item.form.amountcredit,
      };
      this.loadingMessage = true;
      await this.addCreditManager(credit);
      this.loadingMessage = false;
    },
    async changePassword() {
      if (this.$refs.formPassword.validate()) {
        let payload = JSON.parse(JSON.stringify(this.formPassword));
        delete payload.user_partner_confirm_password;
        this.changingPassword = true;
        let result = await this.changePasswordManager(payload);
        this.changingPassword = false;
        if (result == false) return;
        this.dialogPassword = false;
      }
    },
    toChangePassword(item) {
      this.formPassword = {
        user_partner_id: item.user_partner_id,
        user_partner_password: "",
        user_partner_confirm_password: "",
      };
      this.dialogPassword = true;
    },
    cancelEdit() {
      this.selectedCustomer = null;
    },
    nameCheck(item) {
      item.user_full_name_temp =
        item.user_first_name + " " + item.user_last_name;
      return item.user_full_name_temp;
    },
    typeCheck(checkData) {
      if (checkData.user_type == "1") {
        checkData.user_type_name_temp = "Weserve";
      } else if (checkData.user_type == "2") {
        checkData.user_type_name_temp = "Facebook";
      }
      return checkData.user_type_name_temp;
    },
    roleCheck(checkData) {
      if (checkData.user_role == "1") {
        checkData.user_role_name_temp = "SuperAdmin";
      } else if (checkData.user_role == "2") {
        checkData.user_role_name_temp = "Admin";
      } else if (checkData.user_role == "3") {
        checkData.user_role_name_temp = "Viewer(Manager)";
      } else if (checkData.user_role == "4") {
        checkData.user_role_name_temp = "Callcenter";
      } else if (checkData.user_role == "6") {
        checkData.user_role_name_temp = "Customer";
      } else if (checkData.user_role == "7") {
        checkData.user_role_name_temp = "Store owner";
      } else if (checkData.user_role == "8") {
        checkData.user_role_name_temp = "RiderManager";
      } else if (checkData.user_role == "9") {
        checkData.user_role_name_temp = "Accounting";
      } else if (checkData.user_role == "10") {
        checkData.user_role_name_temp = "Marketing";
      } else if (checkData.user_role == "11") {
        checkData.user_role_name_temp = "AdminLaborStore";
      } else {
        checkData.user_role_name_temp = "Other";
      }
      return checkData.user_role_name_temp;
    },
    editItem(item) {
      let userItem = JSON.parse(JSON.stringify(item));
      delete userItem.user_partner_province;
      delete userItem.user_partner_district;
      userItem.user_partner_province_id =
        item.user_partner_province.province_id;
      userItem.user_partner_district_id = item.user_partner_district.map(
        (val) => val.district_id
      );
      this.selectedItem = userItem;
      this.editDialog = true;
    },
    AddCredit() {
      this.AddCreditDialog = true;
    },
    toDeleteItem(item) {
      this.deleteDialog = true;
      this.selectedItem = JSON.parse(JSON.stringify(item));
    },
    async deleteItem() {
      this.isDeleting = true;
      let result = await this.$store.dispatch(
        "fetchUserBack/deleteManager",
        this.selectedItem.user_partner_id
      );
      this.isDeleting = false;
      if (result == false) return;
      let index = this.userList.findIndex(
        (val) => val.user_partner_id == this.selectedItem.user_partner_id
      );
      this.userList.splice(index, 1);
      this.deleteDialog = false;
    },
    async getData() {
      this.loadingMessage = true;
      this.userList = await this.$store.dispatch(
        "fetchUserBack/fetchManagerUserList"
      );
      this.loadingMessage = false;
    },
    async setVIP(value, item) {
      let result = await this.setUserToVIP({
        user_id: item.user_id,
        user_level_status: value.status,
        otp_pin: value.otp_pin,
        otp_ref: value.otp_ref,
        otp_tel: value.otp_tel,
      });
      if (result === false || result.msg == false) {
        item.user_vip = !item.user_vip;
        this.errSnackbar = true;
        this.snackBarMsg = result.data;
      }
    },
    async addUser(payload) {
      delete payload.form.user_partner_confirm_password;
      let result = await this.$store.dispatch(
        "fetchUserBack/addManagerUser",
        payload.form
      );
      payload.done();
      if (result === true) {
        this.dialog = false;
        this.getData();
      } else {
        alert("เบอร์โทรศัพท์ซ้ำหรือมีบางอย่างผิดพลาด");
      }
    },
    async editUser(payload) {
      let result = await this.$store.dispatch(
        "fetchUserBack/editManagerUser",
        payload.form
      );
      payload.done();
      if (result === true) {
        this.editDialog = false;
        this.getData();
      } else {
        alert("เบอร์โทรศัพท์ซ้ำหรือมีบางอย่างผิดพลาด");
      }
    },
    toSetDefaultPayment(item) {
      console.log(item);
      this.setDefaultPaymentDialog = true;
      let user_partner_district = item.user_partner_district.filter(
        (val) => val.default_payment == true
      );
      this.defaultPaymentForm = {
        user_partner_id: item.user_partner_id,
        user_partner_district_id: user_partner_district.map(
          (val) => val.district_id
        ),
        user_partner_province_id: item.user_partner_province.province_id,
      };
      this.managerDistrictList = item.user_partner_district;
    },
    async submitDefaultPayment() {
      this.settingDefault = true;
      let result = await this.setDefaultPaymentManager(this.defaultPaymentForm);
      this.settingDefault = false;
      if (result == false) return alert("บางอย่างผิดพลาด");

      this.userList = result;
      this.setDefaultPaymentDialog = false;
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style>
.body__district::-webkit-scrollbar {
  display: none;
  max-height: 150px;
  overflow: auto;
}
</style>
